import {apiAuthFetcher, apiFetcher} from "~/lib/fetchers";
import type { operations } from "~/types/api-types";

export type GuestbookSearchResponse =
  operations["getGuestbookMessages"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"];
export type GuestbookSearchQuery =
  operations["getGuestbookMessages"]["parameters"]["query"];

export async function getGuestbook(
  query: GuestbookSearchQuery,
): Promise<GuestbookSearchResponse> {
  return apiFetcher<GuestbookSearchResponse>("/public/guestbook", {
    method: "GET",
    params: {
      ...query,
    },
  });
}

export type GuestbookCreateRequest =
  operations["postGuestbookMessage"]["requestBody"]["content"]["application/json"];

export async function postGuestbookMessage(request: GuestbookCreateRequest) {
  return apiFetcher("/public/guestbook", {
    method: "POST",
    body: { ...request },
  });
}

export type GuestbookReplyCreateRequest =
  operations["postGuestbookReply"]["requestBody"]["content"]["application/json"];

export async function postGuestbookMessageReply(
  request: GuestbookReplyCreateRequest,
) {
  return apiFetcher("/public/guestbook/reply", {
    method: "POST",
    body: { ...request },
  });
}

export type AdminGuestbookSearchQuery =
  operations["adminGetGuestbookMessages"]["parameters"]["query"];

export type AdminGuestbookSearchResponse =
  operations["adminGetGuestbookMessages"]["responses"]["200"]["content"]["application/cz.trieu.zmrzlina2ad-v1+json"];

export async function adminGetGuestbook(
  query: AdminGuestbookSearchQuery,
): Promise<AdminGuestbookSearchResponse> {
  return apiAuthFetcher<AdminGuestbookSearchResponse>("/admin/guestbook", {
    method: "GET",
    params: {
      ...query,
    },
  });
}

export async function deleteGuestbookMessage(id: string) {
  return apiAuthFetcher(`/admin/guestbook/${id}`, {
    method: "DELETE",
  })
}

export async function deleteGuestbookReply(id: string) {
  return apiAuthFetcher(`/admin/guestbook/reply/${id}`, {
    method: "DELETE",
  })
}

export type AdminGuestbookMessagePatchRequest = operations["patchGuestbookMessage"]["requestBody"]["content"]["application/json"]
export async function patchGuestbookMessage(id: string, request: AdminGuestbookMessagePatchRequest) {
  return apiAuthFetcher(`/admin/guestbook/${id}`, {
    method: "PATCH",
    body: {
      ...request
    }
  })
}

export type AdminGuestbookReplyPatchRequest = operations["patchGuestbookReply"]["requestBody"]["content"]["application/json"]
export async function patchGuestbookReply(id: string, request: AdminGuestbookReplyPatchRequest) {
  return apiAuthFetcher(`/admin/guestbook/reply/${id}`, {
    method: "PATCH",
    body: {
      ...request
    }
  })
}
